import React from 'react';

import { initialState as IS } from '../modules/form/reducer';

export const StoreContext = React.createContext(null);
// eslint-disable-next-line react/prop-types
const StoreProvider = ({ children }) => {
  const [dayData, setDayData] = React.useState([]);
  const [incurredDate, setIncurredDate] = React.useState(IS.incurredDate);
  const [incurredAmount, setIncurredAmount] = React.useState(IS.incurredAmount);

  const [paymentFrequency, setPaymentFrequency] = React.useState(
    IS.paymentFrequency
  );
  const [paymentFrequencyAmount, setPaymentFrequencyAmount] = React.useState(
    IS.paymentFrequencyAmount
  );
  const [paymentFrequencyStartDate, setPaymentFrequencyStartDate] =
    React.useState(IS.paymentFrequencyStartDate);

  const [frequency, setFrequency] = React.useState();
  const [installments, setInstallments] = React.useState(IS.installments);
  const [payments, setPayments] = React.useState(IS.payments);

  const [installmentRangeFirstDate, setInstallmentRangeFirstDate] =
    React.useState();
  const [installmentRangeLastDate, setInstallmentRangeLastDate] =
    React.useState();
  const [installmentRangeAmount, setInstallmentRangeAmount] = React.useState();
  const [installmentRangeFrequency, setInstallmentRangeFrequency] =
    React.useState();

  const [finalPaymentDate, setFinalPaymentDate] = React.useState();

  const store = {
    dayData: [dayData, setDayData],
    incurredDate: [incurredDate, setIncurredDate],
    incurredAmount: [incurredAmount, setIncurredAmount],

    installments: [installments, setInstallments],

    // Installment range states
    installmentRangeFirstDate: [
      installmentRangeFirstDate,
      setInstallmentRangeFirstDate,
    ],
    installmentRangeLastDate: [
      installmentRangeLastDate,
      setInstallmentRangeLastDate,
    ],
    installmentRangeAmount: [installmentRangeAmount, setInstallmentRangeAmount],
    installmentRangeFrequency: [
      installmentRangeFrequency,
      setInstallmentRangeFrequency,
    ],

    paymentFrequency: [paymentFrequency, setPaymentFrequency],
    paymentFrequencyAmount: [paymentFrequencyAmount, setPaymentFrequencyAmount],
    paymentFrequencyStartDate: [
      paymentFrequencyStartDate,
      setPaymentFrequencyStartDate,
    ],
    frequency: [frequency, setFrequency],
    payments: [payments, setPayments],
    finalPaymentDate: [finalPaymentDate, setFinalPaymentDate],
  };

  return (
    <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
  );
};

export default StoreProvider;
